import React from 'react';


const WelcomePage = ({ onNext }) => {
    return (
        <div className="welcome-page">
            <div className="welcome-header">
                <div className="welcome-title">ИГРА-ТРЕНАЖЕР</div>
                <div className="welcome-logo">
                    <div className="logo-inner">ЭЛИТНЫЙ ЛЕГИОН</div>
                </div>
            </div>

            <div className="welcome-content">
                <div className="welcome-description">
                    <div className="welcome-heading">Автор: Яна IVАнченко</div>
                    <div className="welcome-text">Эксперт по управлениею командами</div>
                </div>

                <button className="welcome-button" onClick={onNext}>
                    Начать
                </button>
            </div>
        </div>
    );
};

export default WelcomePage; 